/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import ToolbarHelper from './ToolbarHelper';
import EditFilterAction from './actions/EditFilterAction';
import StringResources from './nls/StringResources';

// -----TEMPORARY-------
// TODO: needs to be removed when we slightly refactor the slot actions returning
// dashboard-analytics paths like so: `dashboard-analytics/dialogs/CommonViewWrapper`
// that are eventually loaded by NextView.js
const DynamicFileLoader = require('dashboard-analytics/DynamicFileLoader');
// ---------------------

export default class LocalFilterDialog {

	constructor(options) {
		this._toolbarHelper = new ToolbarHelper();
		this.dashboard = options.dashboard;
		this.content = options.content;
	}

	renderDialog(metadataColumnId, renderNode, editorOptions) {
		const visualization = this.content.getFeature('Visualization');
		const metadataColumn = visualization.getDataSource().getMetadataColumn(metadataColumnId);
		const fAction = new EditFilterAction(this.dashboard, this.content, metadataColumn);

		if (!editorOptions.forceOpen && metadataColumn.isNamedSet()) {
			const localFilters = visualization.getLocalFilters();
			localFilters.addFilter(fAction.itemContext, {
				command: 'replace',
				exclude: false,
				valueDataItem: metadataColumn.getId(),
				type: metadataColumn.isProperty() ? 'display' : undefined
			});
		} else {
			const sDialogModule = fAction.getEditorModuleName();
			const viewOptions = fAction.getViewOptions();

			return DynamicFileLoader.load([sDialogModule])
				.then((modules) => {
					return new modules[0](viewOptions);
				})
				.then((view) => {
					const preloadDone = (this.preload && this.preload()) || ((view.preload) ? view.preload() : Promise.resolve()); // required for unit tests
					return preloadDone.then(this._createContextFilter.bind(this, view, renderNode, editorOptions))
						.then(() => {
							return view.renderCallBack(this._toolbarHelper.getToolbar());
						});
				});
		}
	}

	_createContextFilter(view, parentNode, editorOptions) {
		const actions = [
			{
				name: 'subview',
				responsive: false,
				editable: false,
				changedAction: null,
				subView: view,
				type: 'SubView'
			}
		];

		// We need to send the popoverContentClass along when creating the toolbar
		// So popovers are sized and positioned correctly
		// Defect #205657, #208527; APAR #123258;
		editorOptions.popoverContentClass = view.$el && view.$el.attr('class');

		this._toolbarHelper.buildActionToolbar(actions, parentNode, StringResources.get('toolbarActionFilter'), editorOptions);
	}

	getAPI() {
		return this.api;
	}
}


// WEBPACK FOOTER //
// ./src/js/LocalFilterDialog.js